var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95381 0 0 8.95381 0 20C0 31.0462 8.95381 40 20 40C31.0462 40 40 31.0462 40 20C40 8.95381 31.0462 0 20 0ZM29.2309 19.2309C29.2494 20.5381 28.9607 21.8291 28.388 23.0046C27.8314 24.1224 27.0231 25.0947 26.0254 25.8453C25.3533 26.3441 24.612 26.7367 23.8245 27.0115C22.9838 27.3048 22.4157 28.0947 22.4157 28.9861V32.4942C22.4157 33.6467 21.4804 34.582 20.3279 34.582C19.1755 34.582 18.2402 33.6467 18.2402 32.4942V29.0139C18.2402 28.1224 17.6744 27.3326 16.8314 27.0393C16.0323 26.7621 15.2725 26.3741 14.5774 25.8822C13.5612 25.1478 12.7413 24.1709 12.1963 23.0416C11.6259 21.8545 11.3372 20.5497 11.3533 19.2333V10.5543C11.3533 9.40185 12.2887 8.46651 13.4411 8.46651H13.4781C14.6305 8.46651 15.5658 9.40185 15.5658 10.5543V19.1986C15.5473 20.0785 15.7691 20.9446 16.2055 21.709C16.6189 22.4157 17.2125 22.9977 17.9284 23.3949C19.3995 24.2009 21.1824 24.2009 22.6536 23.3949C23.3672 22.9977 23.963 22.4157 24.3741 21.709C24.8129 20.9469 25.0346 20.0785 25.0162 19.1986V10.5543C25.0162 9.40185 25.9515 8.46651 27.1039 8.46651H27.1409C28.2933 8.46651 29.2286 9.40185 29.2286 10.5543V19.2356L29.2309 19.2309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoIconWhite);
export default __webpack_public_path__ + "static/media/NewLogoIconWhite.7b5dba4353453a66e0172996986b5cc7.svg";
export { ForwardRef as ReactComponent };